import React, { useState, useContext, useEffect } from "react";
import { TranslationContext, TranslationContextProvider } from "../../commons/context/TranslationContext";
import { asyncSetter } from "../../commons/api/GetFeatureStatus";
export const ScrubInterface = ({children}) => {

  const {translationDispatch} = useContext(TranslationContext)

  useEffect(() => {
    translationDispatch({ 
      type:"LOAD_DATA",
      data: {
          stringSets: ["scrub"], 
          dispatcher: translationDispatch
        }
    });
    return () => translationDispatch({ type: "UNLOAD_DATA" });
  }, []);

  return (<React.Fragment>
    {children}
  </React.Fragment>)
};

export const Predicate = ({featureName, children}) => {
  const [isFeatureEnabled, setFeatureEnabled] = useState(false);
  useEffect(() => {
    asyncSetter({ featureName}, setFeatureEnabled);
  }, [featureName]);
  return (isFeatureEnabled ? children: <React.Fragment></React.Fragment>);
};


export const withScrubInterface = (Component) => () => {

  return (
    <Predicate featureName="AGEING_SCRUB" >
      <TranslationContextProvider>
      <ScrubInterface>
          <Component></Component>
      </ScrubInterface>
      </TranslationContextProvider>
    </Predicate>
  );
}



// WEBPACK FOOTER //
// ./src/components/scrub/ScrubInterface.js